import { useEffect, useCallback } from 'react';

type MessageValueType = string | number;

export type MessageType<T extends MessageValueType> = {
  type: T;
  payload?: unknown;
};

type MessageHandlerMap<T extends MessageValueType> = Partial<
  Record<T, (payload?: unknown) => void>
>;

export const useIframeMessageListener = <T extends MessageValueType>(
  handlers: MessageHandlerMap<T>,
) => {
  const handleMessage = useCallback(
    (event: MessageEvent<MessageType<T>>) => {
      const messageHandler = handlers[event.data.type];
      if (messageHandler) {
        messageHandler(event.data.payload);
      }
    },
    [handlers],
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
};
